import React from "react";
import Skelton from "../Skelton";

interface CardProps {
  svg: React.ReactNode;
  title: string;
  counter?: number;
  // icon: React.ReactNode;
  // percent: string;
  // spanClass: string;
  isloading?: boolean;
}

const Card: React.FC<CardProps> = ({
  svg,
  title,
  counter,
  // icon,
  // spanClass,
  // percent,
  isloading,
}) => {
  return (
    <div className="bg-white rounded-xl p-4 shadow-lg flex items-center gap-2">
      <div>{svg}</div>
      <div>
        <h1 className="text-3xl font-semibold min-h-9">
          {isloading ? <Skelton type="text" height="h-9" /> : counter}
        </h1>
        <p className="text-gray-800 text-sm">{title}</p>
        {/* <div className="flex items-center mt-2">
          <span
            className={`w-5 h-5  rounded-full flex justify-center items-center ${spanClass}`}
          >
            {icon}
          </span>
          <span className="ms-1 text-xs text-gray-400 flex-1">
            {isloading ? <Skelton type="text" /> : percent}
          </span>
        </div> */}
      </div>
    </div>
  );
};

export default React.memo(Card);
